import { Config } from "./context";

export function oneOfKeysChanged<P extends {}>(
  keys: Array<keyof P>,
  prev: P,
  next: P
) {
  // tslint:disable-next-line: prefer-for-of
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if (prev[key] !== next[key]) {
      return true;
    }
  }

  return false;
}

export function getLabel(
  label: Config["label"],
  key: Config["key"],
  t: any
): string {
  if (label) {
    // label is function -> pass through translation function
    if (typeof label === "function") {
      const result = label(t);
      if (result) {
        return result;
      }
    }

    // label is just plain string
    return label as string;
  }

  // fallback to key of object
  return key as string;
}

export function getColumnValue(row: any, config: Config, t: any) {
  const { resolveValue, key } = config;

  const value = row[key];

  if (!resolveValue) {
    return value;
  }

  try {
    return resolveValue({ value: row[key], t, row });
  } catch (e) {
    throw new Error(
      `Error while resolving value in Table(Cell) component. \n Key: ${key as string} \n ${JSON.stringify(
        row,
        null,
        2
      )} `
    );
  }
}
